import React, { useContext, useEffect, useState } from 'react';
import { ShoppingBag, Shirt } from 'lucide-react';
import { cop, errorApi, imgSrc, TiendaApi } from './tiendaUtils';

const TarjetaProducto = ({ p, onElegir }) => (
  <article className="flex flex-col overflow-hidden rounded-2xl border border-[#27272A] bg-[#18181B] transition-colors hover:border-[#C9A962]/40" data-testid={`tienda-producto-${p.id}`}>
    <div className="relative aspect-[4/3] bg-zinc-100">
      {p.imagen_url
        ? <img src={imgSrc(p.imagen_url)} alt={p.nombre} className="h-full w-full object-contain p-4" loading="lazy" />
        : <Shirt className="absolute inset-0 m-auto h-16 w-16 text-zinc-400" />}
      {p.etiqueta && <span className="absolute left-3 top-3 rounded-full bg-[#C9A962] px-3 py-1 text-xs font-semibold text-black">{p.etiqueta}</span>}
    </div>
    <div className="flex flex-1 flex-col gap-2 p-5">
      <h3 className="font-serif text-lg font-medium text-white">{p.nombre}</h3>
      {p.descripcion && <p className="text-sm leading-relaxed text-zinc-400">{p.descripcion}</p>}
      <p className="mt-auto pt-2 text-2xl font-semibold text-[#C9A962]" data-testid={`tienda-precio-${p.id}`}>
        {cop(p.precio)} <span className="text-xs font-normal text-zinc-500">COP {p.precio_nota}</span>
      </p>
      <button onClick={() => onElegir(p.id)} className="mt-2 w-full rounded-xl bg-[#C9A962] py-3 font-semibold text-black transition-colors hover:bg-[#D4B872]" data-testid={`tienda-personalizar-${p.id}`}>
        Personalizar y comprar
      </button>
    </div>
  </article>
);

export default function ListaProductos({ onElegir }) {
  const api = useContext(TiendaApi);
  const [productos, setProductos] = useState(null);

  useEffect(() => {
    api.productos()
      .then(r => setProductos(r.data.productos))
      .catch(e => { setProductos([]); console.error(errorApi(e, 'No se pudieron cargar los productos')); });
  }, [api]);

  return (
    <section className="space-y-5" data-testid="tienda-seccion">
      <div>
        <h2 className="text-xl font-serif font-medium text-white">{api.invitado ? 'Explora la colección' : 'Productos disponibles para compra online'}</h2>
        <p className="mt-1 text-sm text-zinc-400">
          {api.invitado ? 'Personaliza tu prenda y paga en línea, sin necesidad de crear una cuenta.' : 'Personaliza tu prenda, usa tus Puntos JPM y paga en línea.'}
        </p>
      </div>
      {productos === null && <div className="h-40 animate-pulse rounded-2xl bg-[#18181B]" />}
      {productos?.length === 0 && (
        <div className="rounded-2xl border border-[#27272A] bg-[#18181B] p-8 text-center" data-testid="tienda-vacia">
          <ShoppingBag className="mx-auto mb-3 h-12 w-12 text-zinc-700" />
          <p className="text-zinc-400">Pronto tendremos productos disponibles para comprar en línea.</p>
        </div>
      )}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {productos?.map(p => <TarjetaProducto key={p.id} p={p} onElegir={onElegir} />)}
      </div>
    </section>
  );
}
